import { Loader2 } from 'lucide-react'
import { cn } from '../utils/cn'

export default function LoadingSpinner({ size = 'medium', className }) {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8'
  }

  return (
    <Loader2 
      className={cn(
        'animate-spin text-primary',
        sizeClasses[size],
        className
      )} 
    />
  )
} 